// extracted by mini-css-extract-plugin
export default {"transactionItem":"IncompleteTransactionsModal_transactionItem__wL51F"};